module.exports = __webpack_public_path__ + "static/media/done.14133df4.svg";